export const TAB_ALIGNMENTS = {
  JUSTIFIED: 'justified',
  LEFT: 'left',
};
